import DefaultCell from "application/components/DefaultCell";


const operationURLS = {
  list: "/report/list",
  pdfDownload: "report/agentAction/generateAndDownloadPdf",
  csvDownload: "report/downloadCSV",
};

const getColumns = () => {
  return [
    {
        Header: "Phone Number",
        accessor: "phoneNumber",
        displayInList: true,
        allowFilter: false,
        dataType: "string",
        Cell: ({ value }) => <DefaultCell value={value}/>,
      },

    {
      Header: "Campaign",
      accessor: "campaign",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value}/>,
    },
    {
      Header: "Agent Flow",
      accessor: "agentFlow",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Agent Action Time",
      accessor: "agentActionTime",
      displayInList: true,
      allowFilter: true,
      dataType: "date",
      dateTime: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
  ];
};

export { getColumns, operationURLS };
